import { ROLES } from "../constant/constants";
import { getParsedNumber } from "./Common";

const loyaltyProgramSettings = {
  isActive: false,
  pointBasedSystem: {
    isActive: false,
    pointPerHundredTKSpent: 0,
    minRedeemPoint: 0,
    redeemRate: 1,
  },
  spentBasedSystem: {
    isActive: false,
    slabs: [],
  },
};

export const tableLayoutDefaultSummary = {
  available: 0,
  onDine: 0,
  occupied: 0,
};

export const getDefaultAuthState = () => ({
  isLoggedIn: false,
  user: null,
  isSuperAdmin: false,
  role: "",
  parentRestaurantId: "",
  restaurantId: "",
  restaurantSlug: "",
  restaurantName: "",
  restaurantLogo: "",
  inventoryType: "",
  isPayLater: false,
  isVatIncluded: true,
  restaurantVat: 0,
  isServiceChargeIncluded: true,
  restaurantServiceCharge: 0,
  isSupplementaryDutyIncluded: true,
  customersPaymentOptions: [],
  adminsPaymentOptions: [],
  totalBranches: 1,
  restaurantCountryCode: "",
  restaurantPhone: "",
  restaurantAddress: "",
  restaurantBin: "",
  restaurantVatRegNo: "",
  restaurantMushak: "",
  restaurantPrinterSettingsInvoice: {},
  restaurantPrinterSettingsKitchenSlip: {},
  invoiceSettingsNameAndLogo: "NAME",
  loyaltyProgramSettings,
  tableManagement: "",
  takeoutTypes: [],
  posBanks: [],
  isQrTableSpecific: false,
  totalTableInRestaurant: 1,
  networkCall: false,
  notifications: [],
  isReloadNeeded: false,
  socialLink: "",
  webAddress: "",
  branches: [],
});

export const getAllBranchList = (restaurants) => {
  const allBranches = [];

  for (let i = 0; i < restaurants.length; i++) {
    const branches = restaurants[i].branches;

    for (let j = 0; j < branches.length; j++) {
      const item = branches[j];
      allBranches.push(item);
    }
  }

  return allBranches;
};

export const getRestaurantState = (userData, defaultBranch) => {
  if (userData.isSuperAdmin) {
    const defaultStateData = getDefaultAuthState();
    // Some state variables need to be over write as defaultStateData used for super admin
    return {
      ...defaultStateData,
      isLoggedIn: true,
      user: userData,
      isSuperAdmin: true,
      role: ROLES.SUPER_ADMIN,
    };
  }

  let restaurantName = defaultBranch.name;
  restaurantName += defaultBranch.totalBranches > 1 ? ` (${defaultBranch.branch})` : "";

  const branchData = {
    parentRestaurantId: defaultBranch.parentRestaurantId,
    restaurantId: defaultBranch.id,
    restaurantSlug: defaultBranch.slug,
    restaurantName,
    restaurantLogo: defaultBranch.logo,
    isPayLater: defaultBranch.acceptPayAfterEat,
    inventoryType: defaultBranch.inventoryType,
    restaurantVat: getParsedNumber(defaultBranch.vat),
    isVatIncluded: defaultBranch.isVatIncluded,
    isSupplementaryDutyIncluded: defaultBranch.isSupplementaryDutyIncluded,
    isServiceChargeIncluded: defaultBranch.isServiceChargeIncluded,
    restaurantServiceCharge: getParsedNumber(defaultBranch.serviceCharge),
    customersPaymentOptions: defaultBranch.customersPaymentOptions,
    adminsPaymentOptions: defaultBranch.adminsPaymentOptions,
    totalBranches: defaultBranch.totalBranches,
    restaurantCountryCode: defaultBranch.countryCode || "",
    restaurantPhone: defaultBranch.phone || "",
    restaurantAddress: defaultBranch.address,
    restaurantBin: defaultBranch.bin || "",
    restaurantVatRegNo: defaultBranch.vatRegNo || "",
    restaurantMushak: defaultBranch.mushak || "",
    restaurantPrinterSettingsInvoice: defaultBranch.printerSettingsInvoice || {},
    restaurantPrinterSettingsKitchenSlip: defaultBranch.printerSettingsKitchenSlip || {},
    invoiceSettingsNameAndLogo: defaultBranch.invoiceSettingsNameAndLogo,
    loyaltyProgramSettings: defaultBranch.loyaltyProgramSettings,
    tableManagement: defaultBranch.tableManagement,
    takeoutTypes: defaultBranch.takeoutTypes,
    posBanks: defaultBranch.posBanks || [],
    socialLink: defaultBranch.socialLink || "",
    webAddress: defaultBranch.webAddress || "",
    branches: getAllBranchList(userData?.restaurants || []),
  };

  // from socket it will come as empty string
  if (defaultBranch.defaultBranchRole) {
    branchData.role = defaultBranch.defaultBranchRole;
  }

  return branchData;
};

// Order store
export const getOrderDefaultFilter = (page = 1) => {
  return {
    sortBy: "NEWEST",
    page,
    perPage: 10,
    searchText: "",
    paymentStatus: "",
    orderStatus: "",
  };
};

export const getFilteredSelectedTables = (tableInfo, tables = []) => {
  const exists = tables.some(
    item =>
      item.floorPlanId === tableInfo.floorPlanId &&
      item.tableId === tableInfo.tableId
  );

  if (exists) {
    // REMOVE if already selected
    return tables.filter(
      item =>
        item.floorPlanId !== tableInfo.floorPlanId ||
        item.tableId !== tableInfo.tableId
    );
  }

  // ADD if not selected
  return [...tables, tableInfo];
};
